import { useEffect } from "react";

import { Row, Col } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import CreateServicioModal from "../servicios/CreateServicioModal";

function ServiciosForm({
  servicios,
  setTotalServicios,
  servicesList,
  setServicesList,
  formaDePago,
  largoPelo,
  setServicios,
  selectedClient,
}) {
  const handleAdd = () => {
    setServicesList([...servicesList, { id: "", servicio: "", precio: 0 }]);
  };

  const handleRemove = (index) => {
    const list = [...servicesList];
    list.splice(index, 1);
    setServicesList(list);
  };

  const handleSelect = (e, index) => {
    // Hacemos una copia del arreglo 'servicesList'
    const list = [...servicesList];
    // Recibimos el valor elegido en el select (puede ser "" o el id del servicio)
    const serviceChoice = e.target.value;

    if (serviceChoice === "") {
      // Si el usuario selecciona el default, generamos un default object
      list[index] = { id: "", servicio: "", precio: 0 };
      setServicesList(list);
    } else {
      // Buscamos el object en servicios a partir del id
      const s = servicios.find((u) => u.id === parseInt(serviceChoice));
      let precio = 0;

      // En base al largo del pelo y a la forma de pago, buscamos el precio
      switch (largoPelo) {
        case "C":
          if (parseInt(formaDePago) === 0 || parseInt(formaDePago) === 2) {
            precio = s.prC;
          } else if (parseInt(formaDePago) === 1) {
            precio = s.prCT;
          } else {
            precio = s.prCT;
          }
          break;
        case "M":
          if (parseInt(formaDePago) === 0 || parseInt(formaDePago) === 2) {
            precio = s.prSL;
          } else if (parseInt(formaDePago) === 1) {
            precio = s.prSLT;
          } else {
            precio = s.prSLT;
          }
          break;
        case "L":
          if (parseInt(formaDePago) === 0 || parseInt(formaDePago) === 2) {
            precio = s.prL;
          } else if (parseInt(formaDePago) === 1) {
            precio = s.prLT;
          } else {
            precio = s.prLT;
          }
          break;
        default:
          console.log("Algo fallo en el Switch");
      }

      // Armamos la el objeto que vamos a guardar en 'servicesList'
      list[index]["id"] = s.id;
      list[index]["servicio"] = s.servicio;
      list[index]["precio"] = precio;

      setServicesList(list);
    }
  };

  // Esta variable lleva la cuenta del total de los servicios
  let total = servicesList.reduce(
    (sum, value) => sum + parseFloat(value.precio),
    0
  );

  // Cada vez que se agrega o elimina un servicio, hacemos la sumatoria
  useEffect(() => {
    setTotalServicios(total);
  }, [servicesList]);

  // Si se cambia la forma de pago, volvemos a cero los servicios elegidos.
  useEffect(() => {
    setServicesList([]);
  }, [formaDePago, selectedClient, largoPelo]);

  return (
    <>
      <div className="d-flex justify-content-between">
        <h4>Servicios:</h4>
        <CreateServicioModal
          servicios={servicios}
          setServicios={setServicios}
        />
      </div>
      {servicesList.map((singleService, index) => (
        <Row key={index} className="d-flex justify-content-center mt-4">
          <Form.Group className="mb-3" as={Col} lg={4}>
            <Form.Label className="text-primary">
              Servicio {index + 1}
            </Form.Label>

            <Form.Select
              onChange={(e) => {
                handleSelect(e, index);
              }}
            >
              <option value={""}>Seleccionar Servicio</option>
              {servicios.length > 0
                ? servicios.map((servicio) => {
                    return (
                      <option key={servicio.id} value={servicio.id}>
                        {servicio.servicio}
                      </option>
                    );
                  })
                : "No hay servicios"}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3" as={Col} lg={2}>
            <Form.Label>Precio</Form.Label>
            <Form.Control disabled value={`$ ${singleService.precio}`} />
          </Form.Group>
        </Row>
      ))}

      {servicesList.length === 0 && (
        <div className="mt-4  d-flex justify-content-center">
          <h5 className="text-muted">Agregar Servicio</h5>
        </div>
      )}

      <div className="d-flex justify-content-center mt-3">
        {(servicesList.length < 8) & (selectedClient.length !== 0) ? (
          <button
            type="button"
            className="btn btn-success btn-sm m-1"
            onClick={handleAdd}
          >
            +
          </button>
        ) : (
          <button
            type="button"
            className="btn btn-dark btn-sm m-1  disabled"
            onClick={handleAdd}
          >
            +
          </button>
        )}
        {servicesList.length > 0 ? (
          <button
            type="button"
            className="btn btn-danger btn-sm m-1"
            onClick={() => handleRemove(servicesList.length - 1)}
          >
            -
          </button>
        ) : (
          <button
            type="button"
            className="btn btn-dark btn-sm m-1 disabled"
            onClick={() => handleRemove(servicesList.length - 1)}
          >
            -
          </button>
        )}
      </div>

      {servicesList.length > 0 && (
        <div className="mt-4  d-flex justify-content-center">
          <h5>Total Servicios: $ {total}</h5>
        </div>
      )}
    </>
  );
}

export default ServiciosForm;
